var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4688 7C12.4688 7.74592 12.156 8.46129 11.5992 8.98874C11.0425 9.51618 10.2874 9.8125 9.5 9.8125C8.71264 9.8125 7.95753 9.51618 7.40078 8.98874C6.84403 8.46129 6.53125 7.74592 6.53125 7C6.53125 6.25408 6.84403 5.53871 7.40078 5.01126C7.95753 4.48382 8.71264 4.1875 9.5 4.1875C10.2874 4.1875 11.0425 4.48382 11.5992 5.01126C12.156 5.53871 12.4688 6.25408 12.4688 7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7C0 7 3.5625 0.8125 9.5 0.8125C15.4375 0.8125 19 7 19 7C19 7 15.4375 13.1875 9.5 13.1875C3.5625 13.1875 0 7 0 7ZM9.5 10.9375C10.6023 10.9375 11.6595 10.5227 12.4389 9.78423C13.2184 9.04581 13.6562 8.04429 13.6562 7C13.6562 5.95571 13.2184 4.95419 12.4389 4.21577C11.6595 3.47734 10.6023 3.0625 9.5 3.0625C8.39769 3.0625 7.34054 3.47734 6.56109 4.21577C5.78164 4.95419 5.34375 5.95571 5.34375 7C5.34375 8.04429 5.78164 9.04581 6.56109 9.78423C7.34054 10.5227 8.39769 10.9375 9.5 10.9375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.93cacec629817cd5845c772caef79682.svg";
export { ForwardRef as ReactComponent };